import React from "react"
import IconCell from "./IconCell"
import "./IconsList.css"

const IconsList = ({ icons }) =>
  icons === null ? (
    <section className="icons">
      <span className="loading">Loading some really cute icons&hellip;</span>
    </section>
  ) : icons.length === 0 ? (
    <section className="icons">
      <span className="loading">Whoops, I can't find that</span>
    </section>
  ) : (
    <section className="icons">
      <ul>
        {icons.map(icon => (
          <IconCell icon={icon} key={icon.name} />
        ))}
      </ul>
    </section>
  )

export default IconsList
